Drupal.behaviors.headerScroll = {
  attach: function (context, settings) {
    const siteHeader = document.querySelector(".header-scroll-js");

    let throttleScroll;
    let lastScrollY = window.scrollY;

    function hasScrolled() {
      let distance = window.scrollY;

      // Detect scroll direction
      if (distance > siteHeader.clientHeight && distance > lastScrollY) {
        // Scrolled down
        siteHeader.classList.add("site-header-scrolled-hidden");
      } else if (distance > siteHeader.clientHeight && distance < lastScrollY) {
        // Scrolled up
        siteHeader.classList.add("site-header-scrolled");
        siteHeader.classList.remove("site-header-scrolled-hidden");
      } else if (distance == 0) {
        // Initial position
        siteHeader.classList.remove("site-header-scrolled");
        siteHeader.classList.remove("site-header-scrolled-hidden");
      }

      lastScrollY = distance;
    }

    // Listen to scroll
    document.addEventListener("scroll", () => {
      clearTimeout(throttleScroll);
      throttleScroll = setTimeout(() => {
        hasScrolled();
      }, 20);
    });
  },
};
